module.exports = __webpack_public_path__ + "static/media/fbsilver.50cc2940.png";